import type { Composer, Work, Performer, Concert, Venue } from '@brent/shared/types'
import apiClient from './client'

export interface SearchResponse {
  composers: Composer[]
  works: Work[]
  performers: Performer[]
  concerts: Concert[]
  venues: Venue[]
  error?: string
}

export async function search(query: string): Promise<SearchResponse> {
  const params = new URLSearchParams({ q: query })
  return apiClient.get<SearchResponse>(`/search?${params}`)
}

export async function searchByWikidata(qid: string): Promise<SearchResponse> {
  const params = new URLSearchParams({ wikidata_id: qid })
  return apiClient.get<SearchResponse>(`/search?${params}`)
}
